













































import Subscription from '@/datatypes/subscription';
import SubscriptionService from '@/services/billing/SubscriptionService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import CustomerText from '@/components/billing/customer-text.vue';
import SubscriptionText from '@/components/billing/subscription-text.vue';

export default Vue.extend({
  data: () => ({
    hasNext: true,
    errorMessage: '',
    nextPointer: undefined as string | undefined,
    subscriptionService: new SubscriptionService(),
    subscriptions: new Array<Subscription>(),
  }),

  components: {
    SnackbarMessageHandler,
    CustomerText,
    SubscriptionText,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  methods: {
    routeChanged() {
      this.getPastDueSubscriptions(undefined);
    },

    customerUrl(customerId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].customer(customerId);
    },

    subscriptionUrl(customerId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].customer(customerId);
    },

    getListOptions(nextPage) {
      return {
        next: nextPage,
        status: 'past_due',
      };
    },

    concatSubscriptionResponse(data: Subscription[]) {
      this.subscriptions = this.subscriptions.concat(data);
    },

    getPastDueSubscriptions(nextPage) {
      if (!nextPage) {
        this.subscriptions = new Array<Subscription>();
      }

      this.subscriptionService.list(this.getListOptions(nextPage)).then((response) => {
        this.concatSubscriptionResponse(response.data.map((data) => new Subscription(
          camelcaseKeysDeep(data),
        )));

        if (!nextPage && this.subscriptions.length === 0) {
          this.errorMessage = 'No past due subscriptions found.';
        }

        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        } else {
          this.nextPointer = undefined;
          this.hasNext = false;
        }

        if (response.data.length === 0) {
          this.hasNext = false;
        }
      });
    },

    requestNextPage() {
      this.getPastDueSubscriptions(this.nextPointer);
    },
  },
});
